import { useEffect } from "react";
import { type QueryKey, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useSupabaseRealtimeInvalidation = (
  channelName: string,
  tables: string[],
  queryKeys: QueryKey[],
) => {
  const queryClient = useQueryClient();
  const tablesKey = tables.join("|");
  const queryKeysKey = JSON.stringify(queryKeys);

  useEffect(() => {
    const channel = supabase.channel(channelName);

    tables.forEach((table) => {
      channel.on(
        "postgres_changes",
        { event: "*", schema: "public", table },
        () => {
          queryKeys.forEach((queryKey) => {
            queryClient.invalidateQueries({ queryKey });
          });
        },
      );
    });

    channel.subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [channelName, queryClient, tablesKey, queryKeysKey]);
};